export default "__VITE_ASSET__8ws1Q97u__"